import React from 'react';
import { bool } from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@fiverr-private/fit';
import { r_check } from '@fiverr-private/fit/icons';

import './style.scss';

const BooleanPricingFactor = ({ included }) => (
    <td className="boolean-pricing-factor">
        <Icon className={classNames('pricing-factor-check-icon', { included })}>
            {r_check()}
        </Icon>
    </td>
);

BooleanPricingFactor.propTypes = {
    included: bool
};

export default BooleanPricingFactor;
